module.exports = __webpack_public_path__ + "static/media/monitor.709673f5.svg";